import styled from "@emotion/styled";
import { ModalType } from "../types";

interface TitleTextProps {
    type: ModalType;
    isHeadingMultiline?: boolean;
}

function omitTitleTextProps(propName: string) {
    switch (propName) {
        case "isHeadingMultiline":
        case "type":
            return false;
        default:
            return true;
    }
}

export const StyledTitleText = styled("span", {
    shouldForwardProp: omitTitleTextProps,
})<TitleTextProps>`
    flex: 1 1 auto;
    min-width: 0;
    word-wrap: break-word;
    ${(props) =>
        !props.isHeadingMultiline &&
        `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `};

    ${({ type }) => {
        switch (type) {
            case "simple":
                return `
                  margin-top: 3px;
              `;
        }
    }}
`;
